// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__maCA7","label":"styles_label__ROcyo","caption":"styles_caption__qaEnx","description":"styles_description__aTG_N","content":"styles_content__lIKHz"};